const API_BASE_URL = process.env.REACT_APP_API_URL ||'https://enigoal-databackend.onrender.com/api';
// 'http://localhost:3001/api'
export const leadsAPI = {
  // Get all leads
  getAllLeads: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.source) params.append('source', filters.source);
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.search) params.append('search', filters.search);

    const response = await fetch(`${API_BASE_URL}/leads/all?${params}`);
    return response.json();
  },

  // Get statistics
  getStats: async () => {
    const response = await fetch(`${API_BASE_URL}/leads/stats`);
    return response.json();
  },

  // Sync Meta leads
  syncMetaLeads: async () => {
    const response = await fetch(`${API_BASE_URL}/meta/sync`, {
      method: 'POST'
    });
    return response.json();
  },

  // Delete lead
  deleteLead: async (id, source) => {
    const response = await fetch(`${API_BASE_URL}/leads/${id}?source=${source}`, {
      method: 'DELETE'
    });
    return response.json();
  },

  // Health check
  checkHealth: async () => {
    const response = await fetch(`${API_BASE_URL}/health`);
    return response.json();
  }
};